import React, { Fragment, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import cn from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash';

import Header from 'components/Header';
import Footer from 'components/Footer';
import User from 'components/Icons/User';
import { Grid, Column } from 'components/Layout';
import {
  checkPreviousAction,
} from 'actions/workflow';

import style from './style.scss';

const Declined = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const workflow = useSelector((state) => state.workflow);
  const applicationId = useSelector((state) => get(state, 'workflow.attributes.entityId'));

  useEffect(() => {
    const key = searchParams.get('key');

    if (key) {
      !get(workflow, 'data') && dispatch(checkPreviousAction({
        data: {},
        url: `/workflows/fsl/${key}/checkin`,
        success: (response) => {
          const routeUrl = response.data && response.data.url;
          navigate(routeUrl);
        },
        fail: () => {
          navigate('/fsl/application', { replace: true });
        },
      }));
    } else {
      navigate('/fsl/application');
    }
  }, []);

  return (
    <Fragment>
      <Header />
      <section className={cn('grid-container fluid section', style['borrowers-apply'])}>
        <div className="grid-container fluid borrowers-message">
          <div className="grid-container">
            <Grid className="grid-margin-x max-limited">
              {applicationId ? (
                <div className="small-12 large-6 large-offset-3" style={{ textAlign: 'left' }}>
                  <p className="mb-0 p-large"><b>Application ID:</b> {applicationId}</p>
                </div>
              ) : null}
              <Column className="small-12 large-6 large-offset-3">
                <User width={80} className={style.user} />
                <h2>Your application is currently pending manual review</h2>
              </Column>
            </Grid>
          </div>
        </div>
      </section>
      <div className={cn('grid-container fluid section', style.message)}>
        <Grid className="grid-margin-x max-limited">
          <Column className="small-12 large-6 large-offset-3">
            <p className="p-xlarge">Please allow seven (7) business days to receive an email with your application status</p>
          </Column>
        </Grid>
      </div>
      <Footer />
    </Fragment>
  );
};

export default Declined;
